import { FC, ReactNode } from 'react'

import { Ellipsis, Text } from '@revolut-internal/ui-kit'

type CustomFilterOptionProps = {
  label?: ReactNode
  description?: ReactNode
}

export const CustomFilterOption: FC<CustomFilterOptionProps> = ({
  label,
  description,
}) => {
  return (
    <>
      <Text use="p">{label}</Text>
      <Text use="p" variant="caption" mt="s-4" color="grey-tone-50">
        <Ellipsis>{description}</Ellipsis>
      </Text>
    </>
  )
}
